import { useSEO } from "@/components/SEO";
import { Eyebrow, Masked, Reveal, ArrowLink } from "@/components/bits";
import CTASection from "@/components/CTASection";
import { SEO, INSIGHT_CATEGORIES } from "@/lib/site";

const Insights = () => {
    useSEO({ title: SEO["/insights"].title, description: SEO["/insights"].description, path: "/insights" });

    return (
        <>
            <section className="relative overflow-hidden pt-32 pb-16 sm:pt-40 sm:pb-20" data-testid="insights-hero">
                <div className="bg-grid-light absolute inset-0 [mask-image:radial-gradient(70%_60%_at_30%_20%,black,transparent)]" aria-hidden="true" />
                <div className="container-x relative">
                    <Eyebrow>Insights</Eyebrow>
                    <Masked
                        lines={["The Economics of", "Profitable Growth."]}
                        className="mt-7 font-display text-4xl font-extrabold leading-[1.05] tracking-tightest sm:text-6xl lg:text-[72px]"
                    />
                    <p className="mt-8 max-w-2xl text-lg leading-relaxed text-slategray sm:text-xl">
                        Executive analysis on revenue growth, revenue recovery, sales productivity, AI & automation, marketing economics, margin improvement, cost reduction, and executive intelligence.
                    </p>
                </div>
            </section>

            <section className="pb-24 sm:pb-32" data-testid="insights-categories">
                <div className="container-x">
                    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
                        {INSIGHT_CATEGORIES.map((c, i) => (
                            <Reveal key={c} delay={i * 0.05}>
                                <div className="group relative h-full overflow-hidden rounded-xl border border-ink/10 bg-white p-6 transition-colors duration-300 hover:border-vantera/50" data-testid={`insight-category-${i + 1}`}>
                                    <p className="font-mono text-[10px] tracking-[0.2em] text-vantera">{String(i + 1).padStart(2, "0")}</p>
                                    <h3 className="mt-6 font-display text-lg font-extrabold tracking-tight">{c}</h3>
                                    <span className="mt-6 inline-block font-mono text-[10px] uppercase tracking-[0.2em] text-slategray transition-colors group-hover:text-vantera">Briefs in development</span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <section className="relative overflow-hidden bg-ink py-20 text-ivory sm:py-28" data-testid="insights-memo">
                <div className="bg-grid-dark absolute inset-0" aria-hidden="true" />
                <div className="container-x relative grid items-center gap-10 lg:grid-cols-[1.2fr_0.8fr]">
                    <div>
                        <Eyebrow dark>The X-Ray Memo</Eyebrow>
                        <Masked inview lines={["Analysis in Development."]} className="mt-6 font-display text-4xl font-extrabold tracking-tightest sm:text-5xl" />
                        <p className="mt-6 max-w-xl text-lg leading-relaxed text-cloud">
                            Vantera's first executive briefs — on the economics of growth, recovery, margin, and cost — are being written now. Check back soon.
                        </p>
                    </div>
                    <div className="lg:justify-self-end">
                        <ArrowLink to="/contact" dark testid="insights-contact-link">Request an Executive Review in the meantime</ArrowLink>
                    </div>
                </div>
            </section>

            <CTASection heading={["Don't Wait for the Brief", "to Find Your Opportunity."]} sub="Request a Business X-Ray and see what's hiding inside your business today." primary="Request Your Business X-Ray" secondary="Book an Executive Review" testid="insights-final-cta" />
        </>
    );
};

export default Insights;